module.exports = "/images/dust-storm@3x.png?491cc254afbf33d009aeae4691a15e72";